import type { RegionAreaAtom, RegionAtom } from '@search/Atoms/RegionAtom.entity';

export const getFilteredAreas = (
  areas: RegionAreaAtom[],
  selected: RegionAreaAtom | RegionAtom | null,
): RegionAreaAtom[] => {
  if (selected?.key === 'any_region') return [];

  if (selected) {
    const filteredAreas = areas.filter(area => {
      const { region } = area;

      return region.toLowerCase().includes(selected.region.toLowerCase());
    });
    return filteredAreas;
  }
  return areas;
};
